export const validation = {
  documentTypeRequired: "Please enter a document type",
  reason: "Please enter a reason",
  documentTypeGreater: "Document type must be greater then 3 characters",
  documentTypeLess: "Document type must be less then 50 characters",
  reasonGreater: "Reason must be greater then 3 characters",
  reasonTypeLess: "Reason  must be less then 50 characters",
  alphabetsValidation: "Please enter only alphabets",
};
